import { render } from "./create_edit_any.vue?vue&type=template&id=37cd51b7&scoped=true"
import script from "./create_edit_any.vue?vue&type=script&lang=js"
export * from "./create_edit_any.vue?vue&type=script&lang=js"

import "./create_edit_any.vue?vue&type=style&index=0&id=37cd51b7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37cd51b7"]])

export default __exports__